export default __webpack_public_path__ + "files/6fc5ee394578425f70dcf6abc47c05c4.mp3";